import React, { memo } from "react";
import styles from "./photo.module.css";
import { TextComponent } from "../../../../../components";
import { Card, Col, List, Row } from "antd";
import { useNavigate } from "react-router-dom";
import Meta from "antd/es/card/Meta";

import img1 from "../../../../../assets/staticImages/vendorimg1.png";
import img2 from "../../../../../assets/staticImages/vendorimg2.png";
import img3 from "../../../../../assets/staticImages/vendorimg3.png";
import img4 from "../../../../../assets/staticImages/vendorimg4.png";
import img5 from "../../../../../assets/staticImages/vendorimg5.png";
import img6 from "../../../../../assets/staticImages/vendorimg6.png";


const data = [
  {
    title: "Makeup Artisits",
    img: img6,
  },
  {
    title: "Decorators",
    img: img2,
  },
  {
    title: "Venues",
    img: img3,
  },
  {
    title: "Photographers",
    img: img4,
  },
  {
    title: "Wedding DJs",
    img: img5,
  },
  {
    title: "Planners",
    img: img1,
  },
  
];

function Photos({details}) {
  return (
    <>
      <TextComponent text={"Gallery"} textClass={styles.galleryHeading}/>
      <Row className={styles.galleryContainer}>
        {details?.photos?.map((item) => (
          <Col style={{ margin: 10 }}>
            <img className={styles.image} src={item?.image} alt="example" />
          </Col>
        ))}
      </Row>
    </>
  );
}

export default Photos;
